//import { HTTP } from '@ionic-native/http/ngx';

import React, { useState, useContext, useEffect } from 'react';
import { Route, Redirect, Switch, useHistory } from 'react-router-dom';



import { Home } from '../pages/zPublic/views/Home';

import { Auth_MerchantID_context } from '../storeState/auth_merchantID_context'

import { Preferences } from '@capacitor/preferences';
import { NativeBiometric } from "capacitor-native-biometric";
import { BiometryType } from "capacitor-native-biometric";
import { useIonRouter } from '@ionic/react';

import Cookie from 'universal-cookie';

import { MerchantLoginCredentials } from '../pages/zPublic/components/LoginCredentials_merchant';


let cookies = new Cookie();


async function setAppDevice(event) {

    //alert('inside setAppDevice');
    //alert(event[0]);
    //alert(event[1]);
    //alert(event[2]);
    //alert(event[3]);

    Preferences.set({
        key: 'isBiometricFingerprintAvilable',
        value: event[0],
    })
    Preferences.set({
        key: 'device',
        value: event[1],
    })
    // Preferences.set({
    //     key: 'baseURL',
    //     value: event[2],
    // })
    
}

async function setAppDevice_fingerprint(event) {

    //alert('inside setAppDevice');
    //alert(event[0]);
    //alert(event[1]);
    //alert(event[2]);
    //alert(event[3]);

    Preferences.set({
        key: 'biometricFingerprint',
        value: event,
    })
    
}

async function setAppDevice_authenticated(event) {

    //alert('inside setAppDevice');
    //alert(event[0]);
    //alert(event[1]);
    //alert(event[2]);
    //alert(event[3]);

    Preferences.set({
        key: 'isAuthenticated',
        value: event,
    })
    
}

async function setWebsocket_wss(event) {

    Preferences.set({
        key: 'websocket',
        value: event,
    })
    
}



async function removeStorageCredentials() {
    
  //  alert("IN REMOVE CREDENTIALS - PRIVATE ROUTE");

    await Preferences.remove({ key: 'accountID' });
    await Preferences.remove({ key: 'company_phoneNumber' });
    await Preferences.remove({ key: 'employeeID' });
    await Preferences.remove({ key: 'employee_first_name' });
    await Preferences.remove({ key: 'employee_last_name' });
    await Preferences.remove({ key: 'employee_company' });
    await Preferences.remove({ key: 'employee_createdBy' });
    await Preferences.remove({ key: 'schemaName' });
    await Preferences.remove({ key: 'isAuthenticated' });
    await Preferences.remove({ key: 'accessRights' });
    await Preferences.remove({ key: 'loginUsername_authenticated' });
    await Preferences.remove({ key: 'loginPassword_authenticated' });
    await Preferences.remove({ key: 'isBiometricFingerprintAvilable' });
    await Preferences.remove({ key: 'biometricFingerprint' });
    await Preferences.remove({ key: 'device' });
    await Preferences.remove({ key: 'sessionID' });
    await Preferences.remove({ key: 'baseURL' });
    await Preferences.remove({ key: 'capability' });
    await Preferences.remove({ key: 'feature' });
    await Preferences.remove({ key: 'cartList' });
    await Preferences.remove({ key: 'fcm_token' });
    await Preferences.remove({ key: 'latitude_current' });
    await Preferences.remove({ key: 'longitude_current' });
    await Preferences.remove({ key: 'chatID_list' });
    await Preferences.remove({ key: 'websocket' });
    await Preferences.remove({ key: 'initial_setup' });

    let remove_cookie = null;

    cookies.remove('session', remove_cookie);


}

function setStorageCredentials_sessionID(event) {

    //alert('In setStorageCredentials_sessionID');
    //alert(event);

    Preferences.set({
        key: 'sessionID',
        value: event,
    })
}

function setStorageCredentials_accessRights(event) {

    Preferences.set({
        key: 'accessRights',
        value: [event[0], event[1], event[2], event[3],  event[4]].toString(),
    })

}


export function PrivateRoute_merchant ({ children, ...rest }) {
//export class PrivateRoute extends React.Component {
//const PrivateRoute: React.FC = () => {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    //alert('In PrivateRoute');
    //alert(authMerchant_objects.acctID);

    let [validation, setValidation ] = useState(null);
    let [acctID, setAccountID ] = useState(authenticatedMerchent_context.acctID);
    let [schema, setSchema ] = useState(authenticatedMerchent_context.schema);
    //let [cookieID, setCookie ] = useState(false);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);

    let [isBiometric_fingerprintAvilable, setIsBiometric_fingerprintAvilable ] = useState(authenticatedMerchent_context.isBiometric_fingerprintAvailable);
    let [biometric_fingerprint, setBiometric_fingerprint] = useState(authenticatedMerchent_context.biometric_fingerprint);
    let [device, setDevice ] = useState(authenticatedMerchent_context.device);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);
    let [wss, setWebsocket ] = useState(authenticatedMerchent_context.websocket);

    let [merchantLoginModal, setMerchantLoginModal] = useState(false);


    let history = useHistory();

    const router = useIonRouter();


      useEffect(() => {

        //alert('In Private Route UseEffect');
        //alert(authenticatedMerchent_context.acctID);
        //alert(authenticatedMerchent_context.sessionID);

        // alert(JSON.parse(authenticatedMerchent_context.session));
        // alert(JSON.parse(authenticatedMerchent_context.session).cookie);


                const requestOptions = {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Accept': 'text/html, application/json',
                        'content-type': 'application/json',
                        //cookie: authenticatedMerchent_context.session,
                        //cookie: cookies.get('session'),
                        
                    },
                    body: JSON.stringify({
                        Tracker: 'session_check',
                        user: authenticatedMerchent_context.acctID,
                        sessionID: authenticatedMerchent_context.sessionID,
                    }),
                }

                //alert(baseURL);

                fetch(baseURL+'merchants_argsApp', requestOptions)
                //Http.request(baseURL+'merchants_argsApp', requestOptions)
                //fetch('http://localhost/', requestOptions)
                .then(res => res.json())
                .then(res => {

                     //alert('PRIVATE ROUTE -  YES FINGERPRINT - CHECKED SESSION');
                    // alert(authenticatedMerchent_context.authenticated);
                    // alert(res.toString());
                    // // alert(authenticatedMerchent_context.biometric_fingerprint);
                    // alert(window.location);
                

                    if ( res.toString() == '1') 
                    {

                        history.push(window.location);
    
                    }

                    else if (res.toString() == '0') 
                    {

                        authenticatedMerchent_context.changeAuthenticated(null);
                        authenticatedMerchent_context.changeSessionID(null);
                        setAppDevice_authenticated(null);
                        window.location.reload(); // Refresh the page on session expiration

                    }

                //if( authenticatedMerchent_context.biometric_fingerprint == 'yes')
                // {


                //             if ( res.toString() == '1') 
                //             {
        
                //                 history.push(window.location);
            
                //             }
        
                //             else if (res.toString() == '0') 
                //             {
        
                //                 //authenticatedMerchent_context.changeAuthenticated(null);
                //                 //setAppDevice_authenticated(null);
                //                 window.location.reload(); // Refresh the page on session expiration
        
                //             }


                // }
                // else if( authenticatedMerchent_context.biometric_fingerprint == 'no')
                // {

                //     setAppDevice(['no', 'desktop']);
                //     setAppDevice_fingerprint('no');

                //     if (res.toString() == '1') 
                //     {
                //         history.push(window.location);


    
                //     }
                //     else
                //     {
                //         //authenticatedMerchent_context.changeAuthenticated(null);
                //         //setAppDevice_authenticated(null);
                //         window.location.reload(); // Refresh the page on session expiration     
                //     }
                // }

                })

      }, [])  



     
const reconnectInterval = 30000;

useEffect(() => {
  let reconnectTimer = null;
  const wsRef = { current: null };

  function connectWebSocket() {
    if (wsRef.current && (wsRef.current.readyState === WebSocket.OPEN || wsRef.current.readyState === WebSocket.CONNECTING)) {
      return; // already connected or connecting
    }

    const isTest = window.location.origin.includes('test');
    const wsURL = isTest ? 'wss://ghanaverifiedtest.com/ws/' : 'wss://ghanaverified.com/ws/';
    const ws = new WebSocket(wsURL);

    wsRef.current = ws;
    authenticatedMerchent_context.changeWebsocket(ws);

    ws.onopen = () => {
      const registrationMessage = JSON.stringify({ type: "REGISTER", userId: acctID });
      ws.send(registrationMessage);
    };

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);

      if (data.type === 'UPDATE_SESSION') {
        cookies.set('session', data.new_cookie);
      }

      if (data.type === 'SESSION_EXPIRED') {
        if (authenticatedMerchent_context.device === 'mobile' && data.sessionId === authenticatedMerchent_context.sessionID) {
          NativeBiometric.verifyIdentity({
            reason: "VERIFY",
            title: "Biometric Setup",
            subtitle: "Authenticate to continue",
            description: "Place your finger on the sensor",
          })
          .then(() => {
            const requestOptions = {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                Tracker: '71000',
                xUsername: authenticatedMerchent_context.loginUsername,
                xPassword: authenticatedMerchent_context.loginPassword,
              }),
            };

            fetch(baseURL + 'merchants_argsApp', requestOptions)
              .then(res => res.json())
              .then(res => {
                const rows = res.out.toString().split('~~~');
                const lines = rows[0].split('|');

                if (["2", "3", "4", "5"].includes(lines[0])) {
                  setStorageCredentials_sessionID(res.id.toString());
                  setAppDevice_authenticated(lines[7]);
                  authenticatedMerchent_context.changeSessionID(res.id.toString());
                  authenticatedMerchent_context.changeBiometric_fingerprint(true);
                  authenticatedMerchent_context.authenticated(lines[7]);
                } else {
                  alert("Fingerprint RETRIEVAL Authentication Failed");
                }
              });

            alert("Fingerprint Authentication Successful");
          })
          .catch(() => {
            window.location.reload();
          });

        } else if (authenticatedMerchent_context.device === 'desktop') {
          
          window.location.reload();
        }
      }
     };

    ws.onerror = (error) => {
      console.error("WebSocket error:", error);
      ws.close(); // triggers onclose
    };

    ws.onclose = () => {
      console.warn("WebSocket closed. Attempting reconnect...");
      reconnectTimer = setTimeout(connectWebSocket, reconnectInterval);
    };
  }

   connectWebSocket(); // initial connect

  return () => {
    if (reconnectTimer) clearTimeout(reconnectTimer);
    if (wsRef.current) wsRef.current.close();
 };
}, []);




    //alert('In PrivateRoute');
    //alert(authenticatedMerchent_context.authenticated);
    //alert(authMerchant_objects.isBiometric_fingerprintAvailable);
    //alert(biometric_fingerprint);

    return (
        <Route
          {...rest}
          render={({ location }) =>
          authenticatedMerchent_context.authenticated != null ? (
              <React.Fragment>
                {children}
            </React.Fragment>
            ) : (
              <Redirect
                to={{
                  pathname: '/', // Redirect to login page or any unauthorized route
                  state: { from: location },
                }}
              />
            )
          }
        />
      );
    

};

